// extracted by css-extract-rspack-plugin
export default {"titleRow":"titleRow-DaWJI6"};